<template>
  <router-link
    class="post_link rr"
    :class="is_attention ? '' : 'normal_link'"
    :to="{ name: 'ColumnSingle', params: { articleId: id } }"
  >
    <div
      class="post_image"
      :class="is_attention ? 'attention_post' : 'normal_post'"
      :style="'background-image: url(' + setImagePath() + ');'"
    >
      <span v-show="is_new || is_ranking != 0" class="post_tag rr" :class="{'new': is_new}">{{ showTag() }}</span>
    </div>
    <div
      class="post_contents"
      :style="is_attention ? 'width: 80%;' : 'width: 57%;'"
    >
      <div class="clump">
        <p class="post_title">{{ title }}</p>
      </div>
      <Time :date="date" v-if="!is_attention"/>
    </div>
  </router-link>
</template>

<script>
import Time from '@/components/fanClub/column/parts/Time';
import Config from '@/config/config';

export default {
  props: ['title', 'thumbnail', 'hashtag', 'date', 'is_new', 'is_ranking', 'id', 'is_attention'],
  components: {
    Time,
  },
  data() {
    return {
      imagePath: Config.APIURL,
      noImagePath: require('../../../assets/images/dummy1.jpg'),
    }
  },
  methods: {
    setImagePath() {
      if(this.thumbnail != null) {
        return this.imagePath + this.thumbnail;
      } else {
        return this.noImagePath;
      }
    },
    showTag() {
      if(this.is_new) {
        return 'New';
      }
      if(this.is_ranking != 0) {
        return this.is_ranking;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.post_link {
  border-bottom: 1px solid  #ccc;
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.post_image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.attention_post {
  min-height: 182px;
  width: 100%;
  margin-bottom: 5px;
}

.normal_link {
  display: flex;
  justify-content: space-between;
}

.normal_post {
  min-height: 73px;
  width: 40%;
}

.post_contents {
  text-align: left;
}

.clump {
  overflow: hidden;
  width: 100%;
}

.clump .post_title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.post_title {
  font-size: 16px;
  overflow: hidden;
}
.post_date {
  font-size: 12px;
  margin-top: 8px;
}

.post_tag {
  border-radius: 0px 100px 100px 0px;
  background-color: #615FF6;
  color: #fff;
  display: block;
  font-size: 12px;
  line-height: 1;
  max-width: 42px;
  padding: 5px;
  text-align: center;
}

.post_hashtag {
  margin-top: 8px;
}
.hashtag_link {
  font-size: 16px;
  line-height: 1;
  margin-right: 8px;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/Post.vue